import { curry } from 'ramda'

export const canRenderInputForType = curry((type, name) => {
  if (name === 'gallery') {
    if (!['gallery'].includes(type)) return false
  }

  if (name === 'options') {
    if (!['multiple', 'select'].includes(type)) return false
  }

  if (name === 'notes') {
    if (['action_plan', 'text', 'gallery', 'informative', 'block', 'coordinates'].includes(type)) return false
  }

  if (name === 'photos') {
    if (['gallery', 'informative', 'block', 'coordinates'].includes(type)) return false
  }

  if (name === 'defaultValue') {
    if (
      [
        'action_plan',
        'pending',
        'gallery',
        'multiple',
        'select',
        'sign',
        'datetime',
        'place_location',
        'place_person',
        'fleet',
        'date',
        'datetime',
        'informative',
        'block',
        'coordinates'
      ].includes(type)
    )
      return false
  }

  if (name === 'nonComplianceConditions') {
    if (!['checkbox', 'numeric', 'float', 'select', 'multiple'].includes(type)) return false
  }

  if (name === 'questionOptions' && type === 'informative') return true

  if (name === 'minAndMax' && !['numeric', 'float'].includes(type)) return false

  if (name === 'calc' && !['calc'].includes(type)) return false

  if (name === 'integration' && !['integration'].includes(type)) return false

  if (name === 'place' && !['place'].includes(type)) return false

  if (name === 'stockOperationType') {
    if (!['stock'].includes(type)) return false
  }

  if (name === 'autofill') {
    if (!['text', 'cpf_cnpj', 'numeric', 'float', 'phoneNumber'].includes(type)) return false
  }

  return true
})
